import styled from "styled-components";

export default styled.div`
  position: absolute;
  z-index: 2;
  top: ${({ theme }) => `${theme.spacing(2)}px`};
  right: ${({ theme }) => `${theme.spacing(2)}px`};
`;
